export enum StripePaymentFlowProgressEnum {
	CheckoutSessioncompleted = 1,
	PaymentSuccessfull = 2,
}
